<div class="cart-wrap" [class.ui-cart-bordered]="isSideLayout">
  <div class="container-fluid cart-header-wrap">
    <div class="font-xl row g-0 cart-component-header">
      <div class="col-2 d-flex align-items-center">
        <i class="icon-chevron-left p-1 ps-2 font-xl"
           *ngIf="showBackBtn"
           (click)="onBack.emit()"></i>
      </div>
      <div class="col text-center">
        <div class="fw-bold">{{ 'cart.header' | translate:{ quantity: quantity } }}</div>
        <div class="font-sm text-muted"><span [translate]="'common.from'"></span>&nbsp;{{ cart?.bakery?.name }}</div>
      </div>
      <div class="col-2 text-end">
        <i class="icon-close p-2 d-md-none d-inline"
           *ngIf="showCloseBtn"
           (click)="onClose.emit()"></i>
      </div>
    </div>
  </div>
  <div class="cart-lines-wrap"
       [class.cart-lines-wrap__overflowed]="maxHeight && maxHeight !== 'auto'"
       [style.maxHeight]="maxHeight">

    <ng-container *ngFor="let line of orderLines; trackBy: trackByOrderLine">
      <div class="cart-line"
           *ngIf="line.details?.applyOnce">
        <div class="cl-content">
          <div class="fw-bold font-lg">
            {{ line.name }}
          </div>

          <div class="mt-2" *ngIf="line.details.description">
            {{ line.details.description }}
          </div>

          <ng-container *ngIf="line.details.url then urlImg else otherImg"></ng-container>

          <ng-template #urlImg>
            <div class="cl-apply-once-img mt-2">
              <img [src]="line.details.url">
            </div>
          </ng-template>

          <ng-template #otherImg>
            <div class="cl-apply-once-img mt-2">
              <img *ngIf="line.details.picture"
                   [src]="line.details.picture | multiImage: 'smallUrl' : true : ''">
            </div>
          </ng-template>

          <div class="my-2">
            <div class="text-pink pointer lh-1 font-sm"
                 [translate]="'cart.deleteCake'"
                 (click)="$event.stopPropagation(); removeProduct(line)">Remove
            </div>
          </div>

        </div>

        <div class="cl-footer d-flex justify-content-end">
          <div class="fw-bold">
            <span [translate]="'common.total'"></span>
            <span class="ms-2">
            {{ line.price | currencyFormat : cartCurrency }}
          </span>
          </div>
        </div>
      </div>

      <div class="cart-line"
           *ngIf="!line.details?.applyOnce"
           [id]="line.id">
        <div class="d-flex"
             [class.without-cake-img]="!isImageSuitable(line)">
          <cart-line-img
            *ngIf="isImageSuitable(line)"
            [alt]="line?.name"
            [image]="line.product.image || line.product.type.image || line.product.type.categoryPicture"
          ></cart-line-img>

          <div class="cl-cake-info align-self-end">
            <div class="fw-bold font-lg text-overflow">
              {{ line.name }}
            </div>
            <div class="cl-variant-name font-sm font-mute text-overflow"
                 *ngIf="!line.product.variant?.isStandard">
              {{ line.product.variant.name }}
            </div>
            <div class="action-links clearfix">
              <div class="float-start text-primary"
                   [translate]="'cart.openCartLine'"
                   (click)="editOrder(line)">Edit
              </div>

              <div class="float-start text-pink"
                   [translate]="'cart.deleteCake'"
                   (click)="$event.stopPropagation(); removeProduct(line)">Remove
              </div>
            </div>

          </div>
        </div>

        <div class="cl-content" *ngIf="line?.orderLines?.length || !line?.size?.details.pieces">
          <cart-order-line-info
            [orderLine]="line"
            [currency]="cartCurrency"
          ></cart-order-line-info>
        </div>

        <div class="cl-footer d-flex justify-content-between">
          <div class="d-flex align-items-center">
            <span class="me-2" [translate]="'cart.orderLine.qty'">Qty.</span>
            <ui-cake-counter
              [count]="line.count"
              [step]="line.size?.details.pieces ? line.productType.increment || 1 : 1"
              [minCount]="minQuantity(line)"
              [maxCount]="maxQuantity(line)"
              [minCountPerProduct]="line.productType.minQuantityPerProduct"
              [size]="'xs'"
              [debounceTimeCount]="900"
              (onCountUpdated)="countUpdated($event, line)"
            ></ui-cake-counter>
          </div>

          <div class="fw-bold">
            <span [translate]="'common.total'"></span>
            <span class="ms-2">
            {{ line.fullPrice | currencyFormat : cartCurrency }}
          </span>
          </div>
        </div>
      </div>
    </ng-container>


    <div class="d-flex justify-content-between invoice-fee-line fw-bold text-pink font-sm"
         *ngIf="cart.invoiceFee">
      <div><span [translate]="'cart.invoiceFee'"></span>:</div>
      <div>{{ cart.invoiceFee | currencyFormat: cartCurrency }}</div>
    </div>

    <cart-delivery
      *ngIf="delivery && delivery.orderId && cart.isDeliveryActive"
      [delivery]="delivery"
      [deliveryType]="cart.uiDeliveryType"
      [currency]="cartCurrency"
      [isSideLayout]="isSideLayout"
      [showDeliveryEdit]="showDeliveryEdit"
      (onEditDelivery)="onEditDelivery.emit()"
    ></cart-delivery>

    <cart-return-packaging
      *ngIf="cart.returnPackaging"
      [returnPackaging]="cart.returnPackaging"
      [currency]="cartCurrency"
      [showEdit]="!isSideLayout || showReturnEdit"
      (onEdit)="onEditReturn.emit()"
    ></cart-return-packaging>

    <cart-discounted-price
      class="mt-3 d-block"
      *ngIf="cart.discountedPrice"
      [discountedPrice]="cart.discountedPrice"
      [currency]="cartCurrency"
    ></cart-discounted-price>
  </div>

  <div class="cart-component-footer position-relative">
    <div class="clearfix">
      <div class="float-start">
        <span class="fw-bold font-xl" [translate]="'cart.totalSum'"></span>
        <span class="font-sm font-mute ms-1" [translate]="'cart.inclVat'"></span>
      </div>
      <div class="float-end fw-bold font-xl">{{ cart.totalPrice | currencyFormat: cartCurrency }}</div>
    </div>

    <button class="btn btn-pink font-lg btn-block mt-2"
            type="button"
            (click)="onContinue.emit()"
            *ngIf="!isSideLayout"
            [translate]="'cart.proceedToCheckout'">
      Go to checkout
    </button>

    <button class="btn btn-outline-pink font-lg btn-block mt-2"
            type="button"
            *ngIf="isSideLayout"
            (click)="onAddMoreClick.emit()"
            [translate]="'cart.addMoreProducts'">
    </button>

    <div class="text-end mt-3">
      <button class="btn btn-text-pink font-sm fw-bold"
              (click)="onClear.emit()"
              [translate]="'cart.clearCart'">
      </button>
    </div>
  </div>
</div>
